import React from 'react';
import {APP_BAR_HEIGHT, VERSION_APP_HEIGHT} from '../../../layouts/constants';
import {makeStyles} from '@material-ui/core';
import {useLocation} from 'react-router-dom';
import {classNames} from '../../../utils/react/className';

const useStyles = makeStyles(() => ({
  iframe: {
    width: '100%',
    height: `calc(100vh - ${APP_BAR_HEIGHT + VERSION_APP_HEIGHT + 16}px)`,
  },
}));

export type ModulePageFrameProps = {
  page: string,
  className?: string,
};

export default function ModulePageFrame({
  page,
  className,
}: ModulePageFrameProps) {
  const classes = useStyles();

  const location = useLocation();

  return (
    <iframe
      src={`/admin/v2/pages/${page}${location.search}`}
      title={page}
      frameborder="0"
      className={classNames(classes.iframe, className)}
    ></iframe>
  );
}
